import React from 'react';
import Login from '../../features/auth/Login';

const LoginPage = () => <Login />;

export default LoginPage;